export default function isMobile() {
    const isLanscape = window.matchMedia('only screen and (orientation:landscape)').matches
    return isLanscape
        ? window.matchMedia('only screen and (max-height: 768px)').matches &&
              window.matchMedia('only screen and (max-width: 1024px)').matches
        : window.matchMedia('only screen and (max-width: 768px)').matches
}
